import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackScreen } from '../services/analyticsService';

/**
 * Automatically tracks screen views whenever the route changes.
 * Mount this once inside HashRouter — it silently fires on every navigation.
 */
const AnalyticsTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Convert hash route to readable screen name, e.g. "/dashboard" → "Dashboard"
    const path = location.pathname.replace(/^\//, '') || 'home';
    const screenName = path
      .split('/')
      .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
      .join(' › ');

    trackScreen(screenName);
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
